import React from 'react';
import { useCurrentFrame, interpolate, AbsoluteFill } from 'remotion';
import { COLORS } from '../constants';
import { PrixiaLogoBig } from '../components/PrixiaLogo';

export const OutroScene: React.FC = () => {
  const frame = useCurrentFrame();

  const logoOpacity = interpolate(frame, [5, 25], [0, 1], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
  });

  const fadeToWhite = interpolate(frame, [90, 120], [0, 1], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
  });

  const tagOpacity = interpolate(frame, [40, 55], [0, 0.5], {
    extrapolateRight: 'clamp',
    extrapolateLeft: 'clamp',
  });

  return (
    <AbsoluteFill style={{ backgroundColor: COLORS.bg }}>
      {/* Subtle glow */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: 500,
          height: 500,
          borderRadius: '50%',
          background: `radial-gradient(circle, ${COLORS.brandIndigo}10, ${COLORS.brandTeal}08, transparent)`,
          transform: 'translate(-50%, -50%)',
          filter: 'blur(50px)',
        }}
      />

      {/* Logo */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -55%)',
          opacity: logoOpacity,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
        }}
      >
        <PrixiaLogoBig startFrame={5} scale={2.5} />

        {/* Copyright */}
        <div
          style={{
            marginTop: 40,
            fontSize: 12,
            color: COLORS.gray,
            fontFamily: 'Inter, system-ui, sans-serif',
            opacity: tagOpacity,
          }}
        >
          &copy; 2026 Prixia. Todos los derechos reservados.
        </div>
      </div>

      {/* Fade to white */}
      <AbsoluteFill
        style={{
          backgroundColor: '#FFFFFF',
          opacity: fadeToWhite,
        }}
      />
    </AbsoluteFill>
  );
};
